<template>
  <div class="add-enterprise h-[calc(100vh-180px)]">
    <div class="add-title">
      创建合同
    </div>
    <el-scrollbar ref="scrollbarRef" class="h-[calc(100%-84px)] mt-[16px]">
      <div v-loading="loading">
        <div v-if="route.query.contractType == '2'" class="base-card-info c-auto">
          <offline-contract-info
            ref="offlineContractInfoRef" 
            enable-enter-key
            :from="from"
            :data="info.freeDetail"
            @key-enter="doSubmit"
          />
        </div>
        <div v-if="route.query.contractType == '2'" class="base-card-info c-auto">
          <offline-signatory
            ref="offlineSignatoryRef"
            enable-enter-key
            :from="from"
            @key-enter="doSubmit"
          />
        </div>
        <div v-if="route.query.contractType == '1'" class="base-card-info c-auto">
          <free-contract-info
            ref="freeContractInfoRef" 
            enable-enter-key
            :data="freeDetailInfo"
            :from="from"
            @key-enter="doSubmit"
            @change-temp="changeTemp"
          />
        </div>
        <div v-if="route.query.contractType == '1'" class="mb-4">
          <free-signatory
            ref="freeSignatoryRef"
            enable-enter-key
            :data="freeDetailInfo"
            :from="from"
            @key-enter="doSubmit"
          />
        </div>
        <div v-if="route.query.contractType == '1'&& freeDetailInfo?.customFieldList&&freeDetailInfo.customFieldList.length" class="base-card-info c-auto">
          <custom-fields
            ref="customFieldsRef"
            enable-enter-key
            :data="freeDetailInfo"
            :from="from"
            @key-enter="doSubmit"
          />
        </div>
        <div class="base-card-info c-auto">
          <div class="info-card-title">
            备注信息
          </div>
          <el-input
            v-model="remark"
            type="textarea"
            :rows="3"
            class="w-[978px] "
            placeholder=""
            maxlength="200"
            show-word-limit
          />
        </div>
      </div>
    </el-scrollbar>
    <div class="flex justify-start mt-[16px]">
      <el-button @click="closeAndBack">
        取消
      </el-button>
      <el-button type="primary" :loading="saveLoading" @click="doSubmit">
        {{ route.query.contractId?'保存并发起合同':'创建' }}
      </el-button>
    </div>
  </div>
</template>

<script setup lang='ts'>
import { queryContractCreate, queryContractCreateDetail, queryFreeContractUpdata, useTabsStore } from '../../../..';
import { useRoute } from 'vue-router';
import { PropType, ref } from 'vue';
import { ElMessage, ElScrollbar } from 'element-plus';
import { IContractCreateParams, IContractDetailVO, IContractFreeDetailVO } from '../../../../types/contracts/contracts';
import FreeContractInfo from './form/FreeContractInfo.vue';
import FreeSignatory from './form/FreeSignatory.vue';
import OfflineContractInfo from './form/OfflineContractInfo.vue';
import OfflineSignatory from './form/OfflineSignatory.vue';
import CustomFields from './form/CustomFields.vue';

defineOptions({ name: 'InitiateContract' });

defineProps({
  from: {
    type: String as PropType<'saas' | 'company' | 'agent' | 'server'>,
    default: 'saas',
  },
});

const { closeAndBack } = useTabsStore();

const route = useRoute();
const info = ref<IContractDetailVO>({} as IContractDetailVO);
const freeDetailInfo = ref<IContractFreeDetailVO>({} as IContractFreeDetailVO);
const loading = ref(false);
const saveLoading = ref(false);
const scrollbarRef = ref<InstanceType<typeof ElScrollbar>>();
const freeContractInfoRef = ref<InstanceType<typeof FreeContractInfo>>();
const freeSignatoryRef = ref<InstanceType<typeof FreeSignatory>>();
const offlineContractInfoRef = ref<InstanceType<typeof OfflineContractInfo>>();
const offlineSignatoryRef = ref<InstanceType<typeof OfflineSignatory>>();
const customFieldsRef = ref<InstanceType<typeof CustomFields>>();

const remark = ref();

async function doSubmit() {  
  let params = {} as IContractCreateParams;

  if (route.query.contractType == '1') {
    const freeContractInfValid = await freeContractInfoRef.value.validate();

    if (!freeContractInfValid) return;

    const freeSignatoryValid = await freeSignatoryRef.value.validate();

    if (!freeSignatoryValid) return;

    if (freeDetailInfo.value?.customFieldList?.length) {
      const customFieldsValid = await customFieldsRef.value.validate();

      if (!customFieldsValid) return;

    }
   
    params = {
      contractId: route.query.contractId ? Number(route.query.contractId) : null,
      contractType: Number(route.query.contractType),
      contractTempId: freeContractInfoRef.value.getValues().contractTempId,
      contractSubject: freeContractInfoRef.value.getValues().contractSubject,
      endTime: freeContractInfoRef.value.getValues().endTime,
      expireTime: freeContractInfoRef.value.getValues().expireTime,
      actorList: freeSignatoryRef.value.getValues().actorList,
      contractCustomFieldList: freeDetailInfo.value?.customFieldList?.length ? customFieldsRef.value.getValues()?.contractCustomFieldList : [],
      remark: remark.value,
    } as IContractCreateParams;
  } else {
    const offlineContractInfofValid = await offlineContractInfoRef.value.validate();

    if (!offlineContractInfofValid) return;

    const offlineSignatoryValid = await offlineSignatoryRef.value.validate();

    if (!offlineSignatoryValid) return;

    params = {
      contractType: Number(route.query.contractType),
      contractSubject: offlineContractInfoRef.value.getValues().contractSubject,
      fileUrl: offlineContractInfoRef.value.getValues().fileUrl,
      expireTime: offlineContractInfoRef.value.getValues().expireTime,
      actorList: offlineSignatoryRef.value.getValues().actorList,
      remark: remark.value,
    } as IContractCreateParams;
  }

  saveLoading.value = true;
  try {
    if (route.query.contractId) {
      await queryFreeContractUpdata(params);
      ElMessage.success('修改成功');
    } else {
      await queryContractCreate(params);
      ElMessage.success('创建成功');
    }
    closeAndBack();
  } catch (error) {
    if ((error as Error).message) ElMessage.error((error as Error).message);
  }
  saveLoading.value = false;
}

async function changeTemp(id) {
  try {
    const { freeDetail } = await queryContractCreateDetail({
      contractType: Number(route.query.contractType),
      contractTempId: id,
    });

    freeDetailInfo.value = freeDetail;
  } catch (error) {
    if ((error as Error).message) ElMessage.error((error as Error).message);
  }
}

async function fetchData() {
  if (route.query.contractId) {
    loading.value = true;
    try {
      info.value = await queryContractCreateDetail({
        contractType: Number(route.query.contractType),
        contractId: String(route.query.contractId),
      });

      freeDetailInfo.value = info.value.freeDetail;
    } catch (error) {
      if ((error as Error).message) ElMessage.error((error as Error).message);
    }
    loading.value = false;
  } else {
    return;
  }
}

fetchData();

</script>

<style lang="scss" scoped>
.add-enterprise {
  .add-title {
    @apply pl-[24px] text-[20px] font-[600] text-[#344767];
  }
}
</style>
